import React from 'react';
import { Box, Link } from '@mui/material';
import uTriperLogo from 'assets/images/utriper-black-logo.png';

const Navbar = () => {
    return (
        <Box
            component="nav"
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1100,
                height: 64,
                display: 'flex',
                alignItems: 'center',
                px: 3,
                backgroundColor: 'rgba(255,255,255 0.85)',
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(0,0,0,0.08)',
            }}>
            <Link
                href="/"
                underline="none"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                <Box
                    component="img"
                    src={uTriperLogo}
                    alt="uTriper-Logo"
                    height={32}
                    sx={{
                        transition: 'transform 0.2s ease',
                        '&:hover': {
                            transform: 'scale(1.04)',
                        },
                    }}
                />
            </Link>
        </Box>
    );
};

export default Navbar;
